import { useFormik } from "formik";
import { useState } from "react";
import ModalComponent from "..";
import { OrganizationForm } from "../../../app/settings/profileSettings";
import { GetSingleUserResponse } from "../../../redux/features/admin/users/users.types";
import { ModalCompProps, OrganizationData } from "../../../utils/types";
import { SettingPageUpdateProfileSchema } from "../../../utils/validations";
import { Button } from "../../buttons/button";
import { SwitchInput } from "../../inputs/switch";
import { TextInput } from "../../inputs/textInput";
import { MiniHeader } from "../../typography/miniHeader";

export const AdminEditUserModal = ({
  open,
  handleClose,
  user,
}: ModalCompProps & {
  user?: GetSingleUserResponse;
}) => {
  const [orgData, setOrgData] = useState<OrganizationData>();
  const [isOrgDataValid, setIsOrgDataValid] = useState(false);

  const {
    values,
    errors,
    touched,
    handleBlur,
    handleSubmit,
    setFieldValue,
    handleChange,
    resetForm,
    isValid,
  } = useFormik({
    initialValues: {
      firstName: user?.data?.fullName ?? "",
      lastName: user?.data?.fullName ?? "",
      email: user?.data?.email ?? "",
      isOrganization: user?.data.organizerType === "Business",
    },
    enableReinitialize: true,
    validationSchema: SettingPageUpdateProfileSchema,
    onSubmit: async (vals) => {
      let mainOrgData = undefined;

      if (vals.isOrganization && orgData) {
        const { isOrganisation, ...other } = orgData;
        mainOrgData = other;
      }

      const payload = {
        firstName: vals.firstName,
        lastName: vals.lastName,
        isOrganisation: vals.isOrganization,
        organisation: mainOrgData
          ? {
              ...mainOrgData,
              logo: mainOrgData?.logo === "" ? undefined : mainOrgData?.logo,
              phoneNumber:
                mainOrgData?.phoneNumber === ""
                  ? undefined
                  : mainOrgData?.phoneNumber,
            }
          : undefined,
      };

      console.log(payload);
    },
  });

  return (
    <ModalComponent
      open={open}
      handleClose={handleClose}
      className=""
      dialogClassName=""
      closeOnOverlayClick
      showHeader
      title={"Edit User"}
      subtitle={undefined}
      showBackIcon={false}
      mobileAnchorBottom
      showCloseIcon={false}
    >
      <form onSubmit={handleSubmit} className="grid grid-cols-2 gap-4">
        <TextInput
          type="text"
          name="firstName"
          value={values.firstName}
          placeholder="Enter first name"
          onChange={handleChange}
          onBlur={handleBlur}
          hasTitle
          title="First name"
          errors={errors.firstName && touched.firstName ? errors.firstName : ""}
        />

        <TextInput
          type="text"
          name="lastName"
          value={values.lastName}
          placeholder="Enter last name"
          onChange={handleChange}
          onBlur={handleBlur}
          hasTitle
          title="Last name"
          errors={errors.lastName && touched.lastName ? errors.lastName : ""}
        />

        <TextInput
          type="text"
          name="email"
          value={values.email}
          placeholder="Enter email"
          onChange={handleChange}
          onBlur={handleBlur}
          hasTitle
          title="Email"
          errors={errors.email && touched.email ? errors.email : ""}
          readOnly
          containerClassName="col-span-full"
        />

        <div className="col-span-full flex items-center gap-4">
          <div className="flex-1">
            <MiniHeader
              header="I am an Organization"
              subheader="Create event as an organization"
            />
          </div>

          <SwitchInput
            checked={values.isOrganization}
            onChange={() => {
              setFieldValue("isOrganization", !values.isOrganization);
            }}
          />
        </div>

        <div className="col-span-full">
          {values.isOrganization && (
            <OrganizationForm
              isOrg={values.isOrganization}
              handleDataChange={(data, isDataValid) => {
                setOrgData(data);
                setIsOrgDataValid(isDataValid);
              }}
              org={user?.data?.organisation}
              useProfileData={false}
              modifyLogo={false}
            />
          )}
        </div>

        <div className="col-span-full flex items-center justify-end gap-2">
          <Button
            text={"Cancel"}
            type="button"
            onClick={() => {
              handleClose();
              resetForm();
            }}
            variation="plain-grey"
            className="max-w-fit"
          />
          <Button
            text={"Save"}
            type="submit"
            onClick={() => {}}
            className="max-w-fit"
            loading={false}
            disabled={(values.isOrganization && !isOrgDataValid) || !isValid}
            variation={"primary"}
          />
        </div>
      </form>
    </ModalComponent>
  );
};
